export default __webpack_public_path__ + "static/weareg58-desktop-2e5d734e4efe16aff14b56f51c4a1f8d.mp4";